module.exports = __webpack_public_path__ + "img/logo-light.8f46963f.png";